import { HttpClient, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from './../../../environments/environment';
import { createHttpParams } from './../../shared/utils/create-http-params.utils';

export abstract class BaseService<T> {
  protected resourceUrl: string;
  private dataSource = new BehaviorSubject(null as T);
  currentData = this.dataSource.asObservable();
  changeData(data: T) {
    this.dataSource.next(data);
  }

  constructor(protected http: HttpClient, entityName: string) {
    this.resourceUrl = `${environment.api_url}/${entityName}`;
  }

  create(entity: T): Observable<HttpResponse<T>> {
    return this.http.post<T>(`${this.resourceUrl}`, entity, {
      observe: 'response'
    });
  }

  read(
    // page: number = 0,
    // size: number = pageSize,
    // filter: string = '',
    // sort: string = ''
    queryParams?: any
  ): Observable<HttpResponse<T[]>> {
    // const params = new HttpParams()
    //   .set('page', page.toString())
    //   .set('size', size.toString())
    //   .set('filter', filter)
    //   .set('sort', sort);
    const params = createHttpParams(queryParams);

    return this.http.get<T[]>(this.resourceUrl, {
      params,
      observe: 'response'
    });
  }

  find(id: number | string): Observable<HttpResponse<T>> {
    return this.http.get<T>(`${this.resourceUrl}/${id}`, {
      observe: 'response'
    });
  }

  export(searchValues): Observable<Blob> {
    const params = createHttpParams(searchValues);

    return this.http.get<Blob>(`${this.resourceUrl}/export`, {
      params,
      responseType: 'blob' as 'json'
    });
  }

  update(entity: T): Observable<HttpResponse<T>> {
    return this.http.put<T>(`${this.resourceUrl}`, entity, {
      observe: 'response'
    });
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {
      observe: 'response'
    });
  }
}
